import * as React from 'react';
export const pinnacleSvg = React.forwardRef(function pinnacleSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#0087CD',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.46 15.116h-1.777l-5.32 4.007V27h5.32v-7.995h3.826c3.172 0 4.885-.78 4.885-4.976V9.514c0-.335-.018-.652-.045-.942l-4.931 3.716c0 2.339-.136 2.855-1.958 2.828Z',
      fill: '#231F20',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14.683 8.77c.653 0 2.71 0 3.082.155.38.181.544.408.607.988l4.723-2.565C22.525 5.698 21.065 5 18.227 5H9.362v9.79l5.321-2.883V8.762v.009Z',
      fill: '#fff',
    }),
  );
});
pinnacleSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var pinnacle = {
  category: 'brand',
  colorable: false,
  name: 'pinnacle',
  svg: pinnacleSvg,
};
